import { RefreshCw, CheckCircle, XCircle } from 'lucide-react'
import type { ToolActivity } from '../types'

export function ToolActivityBar({ activities, status }: { activities: ToolActivity[]; status: string | null }) {
  if (activities.length === 0 && !status) return null

  return (
    <div className="mx-auto max-w-3xl px-6 py-2">
      <div className="rounded-lg border border-accent/30 bg-accent-soft/50 p-3 space-y-2">
        {status && (
          <div className="flex items-center gap-2 text-xs text-accent">
            <RefreshCw className="h-3 w-3 animate-spin" />
            <span>{status}</span>
          </div>
        )}
        {activities.map((activity) => (
          <div key={activity.id} className="flex items-center gap-2 text-xs">
            {activity.status === 'running' ? (
              <RefreshCw className="h-3 w-3 animate-spin text-accent" />
            ) : activity.status === 'success' ? (
              <CheckCircle className="h-3 w-3 text-success" />
            ) : (
              <XCircle className="h-3 w-3 text-destructive" />
            )}
            <span className="font-medium text-foreground">
              {activity.provider.charAt(0).toUpperCase() + activity.provider.slice(1)}
            </span>
            <span className="text-muted-foreground">&rarr;</span>
            <span className="text-muted-foreground">
              {activity.tool.replace(activity.provider + '_', '').replace(/_/g, ' ')}
            </span>
            {activity.summary && (
              <>
                <span className="text-subtle-foreground">&middot;</span>
                <span className="text-muted-foreground">{activity.summary}</span>
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
